import React from 'react'
import { renderToStaticMarkup } from "react-dom/server";

class ClaimDetails extends React.Component {
  constructor(props) {
    super(props)

    this.state = { 
      details: [],
      description: '',
    }
  }

  componentDidMount() {
    this.showSpinner()
    $.ajax({
      url: `/claims/${this.props.claimId}/claim_details`,
      type: 'GET',
      timeout: 120000,
      success: (data) => {
        this.setState({
          details: data
        })
        this.hideSpinner()
        if (!data.length) {
          this.setState({
            description: this.props.description
          })
        }
      },
      error: this.hideSpinner.bind(this)
    })
  }

  componentDidUpdate() {
    if (this.props.hasCustomContentNumber) {
      const wantedDiv = renderToStaticMarkup(this.renderClaimDetails())
      gon.company_variables['claim.identification_numbers'] = wantedDiv
      PubSub.publish('fetchCustomizeIframe')
    }
  }

  showSpinner() {
    const spinner = new Spinner().spin()
    const spinnerContainer = `.claim-detail-${this.props.claimId}`
    $(spinnerContainer).append(spinner.el)
  }

  hideSpinner() {
    const spinnerDiv = `.claim-detail-${this.props.claimId} > .spinner`
    $(spinnerDiv).remove()
  }

  renderDetail(detail) {
    let {
      product_desc,
      external_claim_id,
      status_desc,
      status_secondary
    } = detail
    
    if(product_desc && status_desc && status_secondary) {
      return(
        <div key={external_claim_id}>
          { `${product_desc} (${external_claim_id}):` }
          <b> { status_desc } </b> - { status_secondary }
        </div>
      )
    } else {
      return (
        <div key={external_claim_id}>
          { ` ${external_claim_id} ` }
        </div>
      )
    }
  }

  renderClaimDetails() {
    return (
      <div className={`claim-detail-${this.props.claimId}`}>
        <div className="claim-item-description">
          <div className='description' dangerouslySetInnerHTML={{__html: this.state.description}} />
        </div>
        { this.state.details.map(detail => this.renderDetail(detail)) }
      </div>
    )
  }

  render() {
    if (this.props.hasCustomContentNumber) {
      return null
    }
    return this.renderClaimDetails()
  }
}

export default ClaimDetails
